export default {
  ENABLE_LOCATION_SERVICES: `Vous devez activer les services de localisation dans les paramètres de votre appareil.`,
  ALLOW_ACCESS: {
    TITLE: `Autoriser Merinio à accéder à votre position`,
    SUMMARY: `Cela permet d'ajouter votre emplacement à votre carte de temps.`,
    USE_TITLE: `Comment nous utiliserons cette information`,
    USE_CONTENT: `Nous l'utiliserons pour confirmer que votre emplacement correspond à l'emplacement de votre quart de travail.`,
    CONTROL_TITLE: `Comment vous pouvez contrôler cela`,
    CONTROL_CONTENT: `Vous pouvez modifier cela à tout moment dans les paramètres de votre appareil.`,
    ALLOW: `Permettre`,
    DONT_ALLOW: `Ne pas permettre`
  },
  CONFIRM_ACCESS: {
    TITLE: `Êtes vous certain?`,
    SUMMARY: `Vous n'avez pas autorisé Merinio à accéder à votre emplacement`,
    CONTENT: `Sans ces informations, nous ne pouvons pas confirmer si votre emplacement correspond à l'emplacement de votre quart de travail.`,
    SHARE: `Partager ma position`,
    DONT_SHARE: `Ne pas partager ma position`
  },
  PUNCH_IN: `Poinçonner entrée`,
  PUNCHED_IN: `Poinçon entrée`,
  PUNCH_OUT: `Poinçonner sortie`,
  PUNCHED_OUT: `Poinçon sortie`,
  APPROVED_TIME: `approuvé`,
  APPROVED_TIME_WEEK: `Ton temps approuvé pour cette semaine est de {{weekPaidHours}}`,
  START_BREAK: `Commencer une pause`,
  END_BREAK: `Finir ma pause`,
  TRANSFER: `Transférer à une autre position`,
  TRANSFER_PROJECT: `Transférer à un autre projet`,
  TRANSFERS: `Transferts`,
  PUNCH_OPTIONS: `Options de poinçon`,
  WRONG_DAY: `Attention, ce quart n'est pas aujourd'hui!`,
  CUSTOM_BREAK: `Pause non planifiée`,
  STATUSES: {
    APPROVED: `Approuvé`,
    NEEDS_APPROVAL: `En attente d'approbation`,
    UNPUNCHED: `Non poinçonné`,
    NOT_PUNCHED_OUT: `Poinçon de sortie manquant`
  },
  notifications: {
    PUNCHED_IN: { title: `Poinçon enregistré`, description: `Vous avez enregistré votre poinçon d'entrée.` },
    PUNCHED_OUT: { title: `Poinçon enregistré`, description: `Vous avez enregistré votre poinçon de sortie.` },
    TRANSFERRED: { title: `Transfert`, description: `Vous avez enregistré votre transfert.` },
    STARTED_BREAK: { title: `Pause débutée`, description: `Vous avez enregistré votre début de pause.` },
    ENDED_BREAK: { title: `Pause finie`, description: `Vous avez enregistré votre retour de pause.` }
  },
  PUNCH_IN_MODAL: {
    TITLE: `Poinçonner entrée`,
    SUMMARY: `Souhaitez vous poinçonner votre entrée?`
  },
  PUNCH_OUT_MODAL: {
    TITLE: `Poinçonner sortie`,
    SUMMARY: `Souhaitez vous poinçonner votre sortie?`
  },
  PUNCH_ADD_COMMENT_MODAL: {
    TITLE: `Ajouter une note`,
    SUMMARY: ``
  },
  LATEARRIVALCOMMENT: `Vous poinçonnez en retard de {{lateArrival}}, vous pouvez laisser une note à votre gestionnaire ci-dessous.`,
  EARLYDEPARTURECOMMENT: `Vous poinçonnez en avance de {{earlyDeparture}}, vous pouvez laisser une note à votre gestionnaire ci-dessous.`,
  EARLYARRIVALCOMMENT: `Vous poinçonnez en avance de {{earlyArrival}}, vous pouvez laisser une note à votre gestionnaire ci-dessous.`,
  LATEDEPARTURECOMMENT: `Vous poinçonnez en retard de {{lateDeparture}}, vous pouvez laisser une note à votre gestionnaire ci-dessous.`,
  TRANSFERPOSITIONCOMMENT: `Vous transférez à une autre position. Vous pouvez laisser une note à votre gestionnaire ci-dessous.`,
  TRANSFERPROJECTCOMMENT: `Vous transférez vers un autre projet. Vous pouvez laisser une note à votre gestionnaire ci-dessous.`,
  COMMENT: {
    LABEL: ``,
    PLACEHOLDER: `Ajouter une note`,
    DESCRIPTION: ``
  },
  TRANSFER_MODAL: {
    TITLE: `Transfert`,
    SUMMARY: ``,
    TRAINED: `Formé`,
    NOT_TRAINED: `Pas formé`
  },
  TRANSFER_PROJECT_MODAL: {
    TITLE: `Transfert vers un autre projet`,
    SUMMARY: ``
  },
  POSITIONID: {
    LABEL: `Position du transfert`,
    DESCRIPTION: `Sélectionnez vers quelle position vous souhaitez transférer votre poinçon.`
  },
  PROJECTID: {
    LABEL: `Projet du transfert`,
    DESCRIPTION: `Sélectionnez vers quel projet vous souhaitez transférer votre poinçon.`
  },
  CUSTOMBREAKREASON: {
    LABEL: `Raison`,
    PLACEHOLDER: `Pourquoi prenez-vous cette pause non planifiée?`,
    DESCRIPTION: ``
  },
  BREAK_START_MODAL: {
    TITLE: `Prendre une pause`,
    SUMMARY: ``,
    BREAKS_IN_SHIFT: `Pauses dans le quart de travail`,
    OTHER_BREAKS: `Autres pauses`
  },
  BREAK_END_MODAL: {
    TITLE: `Finir pause`,
    SUMMARY: `Souhaitez vous finir votre pause?`
  },
  SELECTEDBREAK: {
    LABEL: `Type de pause à prendre`,
    DESCRIPTION: `Sélectionnez la pause que vous désirez prendre.`
  }
}
